import React, { useEffect, useRef, useState } from 'react';
import { getCourseBatch } from '../Services/Api';
import './CourseCard.css';
import { Link,useNavigate } from 'react-router-dom';

const CourseCard = ({ categoryId = null }) => {
  const sliderRef = useRef(null);
  const [courses, setCourses] = useState([]);
  const [index, setIndex] = useState(0);
  const [visibleCount, setVisibleCount] = useState(getVisibleCount());
  const [loading, setLoading] = useState(true);
  const indexRef = useRef(0);

  const navigate = useNavigate();


  function getVisibleCount() {
    const width = window.innerWidth;
    if (width < 600) return 1;
    if (width < 992) return 2;
    return 3;
  }

  const updateSlider = () => {
    if (!sliderRef.current || courses.length === 0) return;
    const card = sliderRef.current.querySelector('.testim-box');
    if (!card) return;
    const cardWidth = card.offsetWidth + parseInt(getComputedStyle(card).marginRight || 30);
    sliderRef.current.style.transform = `translateX(-${index * cardWidth}px)`;
    sliderRef.current.style.transition = 'transform 0.5s ease-in-out';
  };

  const moveSlider = (dir) => {
    const maxIndex = Math.max(courses.length - visibleCount, 0);
    let newIndex = index + dir;
    if (newIndex < 0) newIndex = maxIndex;
    if (newIndex > maxIndex) newIndex = 0;
    indexRef.current = newIndex;
    setIndex(newIndex);
  };
useEffect(() => {
  const fetchCourses = async () => {
    try {
      // 🔥 1. Check localStorage first
      const cached = localStorage.getItem(`courses_${categoryId}`);

      if (cached) {
        setCourses(JSON.parse(cached));
        setLoading(false);  // no skeleton
        return; // stop here — no API call
      }

      // 🔥 2. First-time visit → show skeleton + fetch API
      setLoading(true);
      const res = await getCourseBatch(categoryId);
      const filtered = res.courses.filter(c => parseInt(c.card_design) === 1);

      setCourses(filtered);

      // Save to cache
      localStorage.setItem(`courses_${categoryId}`, JSON.stringify(filtered));

    } catch (err) {
      console.error("Error fetching courses:", err);
    } finally {
      setLoading(false);
    }
  };

  fetchCourses();
}, [categoryId]);


  useEffect(() => {
    const handleResize = () => setVisibleCount(getVisibleCount());
    window.addEventListener('resize', handleResize);

    if (courses.length <= visibleCount) return;

    const interval = setInterval(() => {
      const maxIndex = Math.max(courses.length - visibleCount, 0);
      let newIndex = indexRef.current + 1;
      if (newIndex > maxIndex) newIndex = 0;
      indexRef.current = newIndex;
      setIndex(newIndex);
    }, 5000);

    return () => {
      window.removeEventListener('resize', handleResize);
      clearInterval(interval);
    };
  }, [courses.length, visibleCount]);

  useEffect(() => {
    updateSlider();
  }, [index, visibleCount, courses]);

  const SkeletonCard = () => (
    <div className="testim-box animate-pulse">
      <p className="h-4 bg-gray-300 rounded w-3/4 mb-3"></p>
      <div className="testim-box-content flex items-center gap-3">
        <div className="w-12 h-12 bg-gray-300 rounded-full"></div>
        <div className="flex-1">
          <div className="h-4 bg-gray-300 rounded w-1/2 mb-2"></div>
          <div className="h-3 bg-gray-200 rounded w-1/3"></div>
        </div>
      </div>
    </div>
  );

  return (
    <div className="testim mt-20"  >
      <div className="container">
        <h2 className="text-left">Explore Our Most Popular Courses</h2>

        {loading ? (
          <div className="testim-content">
            <div className="testim-slider" ref={sliderRef}>
              {Array.from({ length: visibleCount * 2 }).map((_, i) => (
                <SkeletonCard key={i} />
              ))}
            </div>
          </div>
        ) : courses.length === 0 ? (
          <p>No courses found.</p>
        ) : (
          <div className="testim-content">
            <div className="testim-slider" ref={sliderRef}>
             {courses.map((course, i) => (
  <div className="testim-box" key={i} onClick={() => navigate(`/about-course/${course.id}`)}>
    <p>{course.purpose_course}</p>

    <div className="testim-box-content">
      <img
        src={`https://edcbackend.lsc-india.org/${course.image}`}
        alt={course.course_name}
      />

      <div>
        <p>{course.course_name}</p>
        {/* <p>{course.category_name}</p> */}

        {/* View Course Button */}
        {/* <Link 
          to={`/about-course/${course.id}`} 
          className="view-link"
          style={{
            display: "inline-block",
            marginTop: "10px",
            padding: "8px 16px",
            background: "#5d4ccf",
            color: "#fff",
            borderRadius: "6px",
            textDecoration: "none",
            fontSize: "14px",
            fontWeight: "600",
            transition: "0.3s"
          }}
        >
          View Course
        </Link> */}

      </div>
    </div>
  </div>
))}

            </div>

            {courses.length > visibleCount && (
              <>
                <button className="prev" onClick={() => moveSlider(-1)}>❮</button>
                <button className="next" onClick={() => moveSlider(1)}>❯</button>
              </>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default CourseCard;
